// Libraries
import React,{useState} from 'react';
import {Popover, PopoverBody} from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';

// Components

// Assets
import styles from './styles.module.scss';

const PATH = 'components/components/editor/components/DropDown/index.jsx';

const defaultProps = {
    sources: [],
    label: '',
    style: {},
    className: {},
    onChange: () => 0,
    translate: (text) => text,
    placement: 'bottom-start',
    modifiers: {},
    uniqueKey: 'test'
};

let DropDown = (props) => {
    const [isOpen, setOpen] = useState(false);
    const {sources = [], label = '', placement = 'bottom-start', uniqueKey, modifiers = {}} = props;

    const togglePopover = () => setOpen(!isOpen);

    const handleOnchange = (option) => {
        try {
            if (typeof props.onChange === 'function') {
                props.onChange(option);
            }

            setOpen(false);
        } catch (error) {
            if (typeof props.onError === 'function') {
                props.onError(error, {
                    component: PATH,
                    action: '',
                    args: {}
                });
            }
        }
    };

    return (
        <>
            <button id={`Popover-${uniqueKey}`} type="button" className={classnames(styles['btn-dropdown'])} onClick={togglePopover}>
                {label || sources[0] && sources[0].label}
                <i className={classnames('icon-antsomi-angle-down', styles['icon-antsomi-angle-down'], {[styles['up']] : isOpen})} />
            </button>
            <Popover
                target={`Popover-${uniqueKey}`}
                isOpen={isOpen}
                toggle={togglePopover}
                trigger={'legacy'}
                hideArrow={true}
                placement={placement}
                className={'antsomi-popover'}
                modifiers={modifiers}
                innerClassName={classnames(styles['popover-inner'])}
            >
                <PopoverBody cssModule={{'popover-body': styles['popover-body']}}>
                    {
                        sources.map((item, index) => {
                            let isActive = item.label === props.label;

                            return <button
                                className={classnames(styles['dropdown-item'], {[styles['active']] : isActive})}
                                key={item.value || index}
                                onClick={() => handleOnchange(item)}
                            >
                                {item.label}
                            </button>;
                        })
                    }
                </PopoverBody>
            </Popover>
        </>
    );
};

DropDown.propTypes = {
    sources: PropTypes.array,
    label: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.object,
    onChange: PropTypes.func,
    translate: PropTypes.func,
    placement: PropTypes.string,
    modifiers: PropTypes.object,
    uniqueKey: PropTypes.string
};

DropDown.defaultProps = defaultProps;

export default DropDown;
